import {
    CUSTOM_FIELD_RESET,
    CUSTOM_FIELDS_RESET,
    CUSTOM_FIELD_FOCUS,
    CUSTOM_FIELD_DOWNLOADED,
    CUSTOM_FIELDS_DOWNLOADED,
    CUSTOM_FIELDS_PENDING,
    CUSTOM_FIELDS_FAILED,
    CUSTOM_FIELD_FAILED,
    CUSTOM_FIELD_POSTING,
    CUSTOM_FIELD_EDITING,
    CUSTOM_FIELD_DELETED,
    CUSTOM_FIELD_DELETING
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: null,
    currentIndex: null,
    currentCustomField: null,
    pending: false,
    sending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case CUSTOM_FIELD_RESET:
            return {
                ...state,
                error: null,
                currentIndex: 0,
                sending: false,
                currentCustomField: null
            };
        case CUSTOM_FIELD_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            newState.content = state.content.filter((cf)  => {
                return cf.id !== action.payload
            });

            if (state.currentCustomField) {
                if (state.currentCustomField.id === action.payload) {
                    newState.currentCustomField = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((cf) => {
                        return newState.currentCustomField.id === cf.id
                    });
                }
            }

            return newState;
        case CUSTOM_FIELDS_RESET:
            return INITIAL_STATE;
        case CUSTOM_FIELDS_PENDING:
            return {
                ...state,
                pending: true
            };
        case CUSTOM_FIELD_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(cf => {
                    return cf.id === action.payload.id
                }),
                currentCustomField: action.payload
            };
        case CUSTOM_FIELD_DOWNLOADED:
            let newContent = [];
            let newIndex;
            let id = action.payload.id;
            let cf = state.content.find(function (cf) {
                return cf.id === id
            });

            if (cf) {
                let index = state.content.findIndex(stateApp => {
                    return stateApp.id === cf.id
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload
                ];
                newIndex = newContent.length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentCustomField: action.payload,
                currentIndex: newIndex
            };
        case CUSTOM_FIELDS_DOWNLOADED:
            let newAppDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentCustomField && action.payload) {
                let newCurrentCustomField = action.payload.find(function (cf) {
                    return cf.id === state.currentCustomField.id
                });
                if (newCurrentCustomField) {
                    newAppDownloadedState.currentCustomField = newCurrentCustomField;
                    newAppDownloadedState.currentIndex = newAppDownloadedState.content.findIndex((cf) => {
                        return newCurrentCustomField.id === cf.id
                    });
                }
            } else {
                newAppDownloadedState.currentCustomField = null;
                newAppDownloadedState.currentIndex = null;
            }

            return newAppDownloadedState;
        case CUSTOM_FIELDS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case CUSTOM_FIELD_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentCustomField: null,
                currentIndex: 0
            };
        case CUSTOM_FIELD_POSTING:
            return {
                ...state,
                sending: true
            };
        case CUSTOM_FIELD_EDITING:
            return {
                ...state,
                sending: true
            };
        case CUSTOM_FIELD_DELETING:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/customfields/reducers.js